import React from 'react';
import Styled from './styled';
import { Items } from '../../shared/consts/shopData';
import Button from 'componets/Button';
import { FaUser } from 'react-icons/fa6';

const index = () => {
  return (
    <Styled.ShopWrapper>
      <Styled.ShopHeader>Shop</Styled.ShopHeader>
      <Styled.ShopContent>
        {Items.map((item, index) => (
          <Styled.ShopItem key={index}>
            <Styled.ImageContainer>
              <img src={item.img} alt={item.title} draggable="false" />
            </Styled.ImageContainer>
           <Styled.ShopContainer>
            <Styled.ShopItemTitle>{item.title}</Styled.ShopItemTitle>
            <Styled.ShopItemDescription>{item.description}</Styled.ShopItemDescription>
            <Styled.ShopItemLower><Styled.ShopItemAuthor><FaUser /> {item.author}</Styled.ShopItemAuthor><Styled.ShopItemPrice>{item.price} ₽</Styled.ShopItemPrice></Styled.ShopItemLower>
           </Styled.ShopContainer>
           <Styled.ShopItemButtonContainer>
              <Button text='Приобрести' onClick={() => window.location.href = `.${item.route}`} />
            </Styled.ShopItemButtonContainer>
          </Styled.ShopItem>
        ))}
      </Styled.ShopContent>
    </Styled.ShopWrapper>
  )
}

export default index